import Layout from '../components/layout/Layout';
import SEO from '../components/shared/SEO';
import JsonLd from '../components/shared/JsonLd';
import HeroSection from '../components/home/HeroSection';
import OverviewSection from '../components/home/OverviewSection';
import HoldingsSection from '../components/home/HoldingsSection';
import BrandsSection from '../components/home/BrandsSection';
import VyasaSection from '../components/home/VyasaSection';
import MarketSection from '../components/home/MarketSection';
import TeamSection from '../components/home/TeamSection';
import AboutSection from '../components/home/AboutSection';
import InsightsSection from '../components/home/InsightsSection';
import CtaSection from '../components/home/CtaSection';
import { useSiteConfig, useBrands, useSubsidiaries } from '../hooks/useApi';

export default function HomePage() {
  const { data: config, isLoading: configLoading } = useSiteConfig();
  const { data: brands, isLoading: brandsLoading } = useBrands();
  const { data: subsidiaries, isLoading: subsLoading } = useSubsidiaries();

  return (
    <Layout>
      <SEO
        title="Apex DeFi Labs Inc. — Building Tomorrow's Capital Markets"
        description="A New York-based technology holding company at the intersection of blockchain infrastructure, AI-powered compliance, and regulated capital markets."
        url="https://apexdefilabs.com"
        type="website"
        keywords="Apex DeFi Labs Inc., VYASA, tokenized securities, Reg D, blockchain infrastructure, AI compliance"
      />
      <JsonLd
        data={{
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: 'Apex DeFi Labs Inc.',
          url: 'https://apexdefilabs.com',
          description:
            'A New York-based technology holding company at the intersection of blockchain infrastructure, AI-powered compliance, and regulated capital markets.',
          address: {
            '@type': 'PostalAddress',
            streetAddress: '100 Church Street',
            addressLocality: 'New York',
            addressRegion: 'NY',
            postalCode: '10007',
            addressCountry: 'US',
          },
          contactPoint: {
            '@type': 'ContactPoint',
            contactType: 'investor relations',
            email: 'info@apexdefilabs.com',
            telephone: '+1-888-666-0441',
          },
        }}
      />
      <HeroSection config={config} isLoading={configLoading} />
      <OverviewSection />
      <HoldingsSection subsidiaries={subsidiaries} isLoading={subsLoading} />
      <BrandsSection brands={brands} isLoading={brandsLoading} />
      <VyasaSection />
      <MarketSection />
      <TeamSection />
      <AboutSection />
      <InsightsSection />
      <CtaSection />
    </Layout>
  );
}
